import axios, {AxiosInstance} from 'axios';
import {Get, Post} from './types';
import {tokenRequestHandler, commonErrorHandler, formatHumpLineTransfer} from './interceptorHandler';
import qs from 'qs';
import { promises } from 'dns';

export const noFormatList: any = [
];

// 创建 Axios 实例
const axiosInstance: AxiosInstance = axios.create({
    timeout: 1200000,
    responseType: 'json',
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
    },
});

// 请求拦截器，后添加的先执行
axiosInstance.interceptors.request.use(tokenRequestHandler.onFulfilled, tokenRequestHandler.onRejected);

// 响应拦截器，后添加的后执行
axiosInstance.interceptors.response.use(commonErrorHandler.onFulfilled, commonErrorHandler.onRejected);

// 封装 get 方法
const get: Get = async (url, params = {}, config) => {
    try {
        const response = await axiosInstance.get(url, {params, ...config});
        return response.data;
    }catch(err){
        return Promise.reject(err)
    }
};

// 封装 post 方法
const post: Post = async (url, data = {}, config, ori) => {
    const {useJsonSerialize = true, ...restConfig} = config || {};
    let requestData: any = {};

    if (!noFormatList.includes(url)) {
        data = formatHumpLineTransfer(data, 'toLine');
    }

    if (!ori) {
        requestData = useJsonSerialize ? JSON.stringify(data) : qs.stringify(data);
    }
    else {
        requestData = data;
    }
    const response = await axiosInstance.post(url, requestData, {
        headers: {
            'content-type': useJsonSerialize ? 'application/json;charset=utf-8' : 'application/x-www-form-urlencoded',
        },
        ...restConfig,
    });
    return response.data;
};

export const request = {get, post};
